module.exports = {
  env: 'production',
  appRoot: '/partners-widgets',
  credibleRoot: 'https://www.credible.com',
  graphqlUri: 'https://www.credible.com/graphql',
  cognitoUserPoolID: 'us-east-1_9fCLAuWkj',
  cognitoClientID: '1jkfo8n3j7tpgkinbff5r8u8c',
  cognitoCookieExpires: 1,
  snowplowEndpoint: 'analytics.credible.com',
  snowplowAppId: 'credible-partners-widgets-production',
  snowplowEncodeBase64: false,
  gtmContainerId: 'GTM-KM5MHR8',
  rollbarTokenClient: 'cb40b49cb3334a328e56c44834ed8339',
  rollbarTokenServer: '04ea9a06b12241718b7bf241a91e9316',
  rollbarEnv: 'widgets_production',
  ratesLibraryUrl: 'https://www.credible.com/rates/js/rates_library.js'
};